import { RouteProps } from '../../routes/AppRouter'
import React from 'react'
import { ArticleForm as AF } from '../../features/article'
import { useTitleHeaderContext } from '../../common/utils/TitleHeaderContext'
import logoCareme from '../../assets/caremePlusLogo.svg'
import style from '../layout/Main.module.css'
import { Box } from '@mui/material'
import { useParams } from 'react-router-dom'

export function ArticlesForm(props: RouteProps) {
  const title = props.title || ''
  const { setTitle } = useTitleHeaderContext()
  const { id } = useParams()

  setTitle(title)

  return (
    <>
      <AF id={id} />
      <Box display={'flex'} justifyContent={'flex-end'}>
        <img src={logoCareme} alt="Logo Careme" className={style.logo} />
      </Box>
    </>
  )
}
